import React from 'react';
import { useRobloky } from '../../context/RoblokyContext';
import { Trophy, CheckCircle2, Info, Users, X } from 'lucide-react';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useRobloky();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed z-50 flex flex-col gap-2.5 left-3 right-3 bottom-20 md:left-auto md:right-6 md:bottom-6 md:w-full md:max-w-sm pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto p-4 rounded-xl border backdrop-blur-md shadow-2xl flex items-start gap-3 transition-all animate-in slide-in-from-bottom-3 ${
            t.type === 'trophy'
              ? 'bg-amber-950/90 border-amber-500/50 text-amber-200'
              : t.type === 'party'
              ? 'bg-cyan-950/90 border-cyan-500/50 text-cyan-200'
              : t.type === 'success'
              ? 'bg-emerald-950/90 border-emerald-500/50 text-emerald-200'
              : 'bg-slate-900/90 border-white/15 text-slate-200'
          }`}
        >
          <div className="shrink-0 mt-0.5">
            {t.type === 'trophy' && <Trophy className="h-4 w-4 text-amber-400" />}
            {t.type === 'party' && <Users className="h-4 w-4 text-cyan-400" />}
            {t.type === 'success' && <CheckCircle2 className="h-4 w-4 text-emerald-400" />}
            {t.type === 'info' && <Info className="h-4 w-4 text-cyan-400" />}
          </div>

          <div className="flex-1 min-w-0">
            <div className="text-xs font-bold font-mono tracking-wide">{t.title}</div>
            {t.message ? (
              <p className="text-xs mt-0.5 leading-tight opacity-90 break-words">{t.message}</p>
            ) : null}
          </div>

          <button
            onClick={() => removeToast(t.id)}
            className="text-slate-400 hover:text-white shrink-0 -mr-1 -mt-1 p-1"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
};
